<div *ngFor="let validator of validators">
  <div *ngIf="validator['validValues']" class="flex flex-column">
    <p-dropdown
      [(ngModel)]="value"
      (ngModelChange)="valueChange.emit(value)"
      [options]="validator['validValues']"
      appendTo="body"
      styleClass="w-full"
    ></p-dropdown>
  </div>
  <div *ngIf="validator['validRange']" class="flex flex-column">
    <p-inputNumber
      [(ngModel)]="value"
      (ngModelChange)="valueChange.emit(value)"
      [min]="validator['validRange'][0]"
      [max]="validator['validRange'][1]"
      styleClass="w-full"
    ></p-inputNumber>
  </div>
  <div *ngIf="validator['required'] !== undefined && !validator['validRange'] && !validator['validValues']" class="flex flex-column">
    <input
      #inputRequired
      (input)="validate(inputRequired)"
      (ngModelChange) = "emitFields($event)"
      [ngModel]="value"
      pInputText
      [required] = "validator['required']"
      class="w-full">
  </div>
</div>
